import { Box, Button, Chip, CircularProgress, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, FormHelperText, IconButton, InputLabel, MenuItem, Select, Switch, TextField, Typography, useTheme } from '@mui/material'
import { useResumeBuilderStore } from '../../../store/resumebuilder.store'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import { Icons } from '../../../utils/utilities'
import { toast } from 'react-toastify'
import { useState } from 'react'
import * as Yup from 'yup'
import React from 'react'
import CustomSelectField from '../../common/CustomSelectField'

const allEntityTypes = [
    { value: "array", label: "Array" },
    { value: "boolean", label: "Boolean" },
    { value: "cgpaorpercentage", label: "CGPA or Percentage" },
    { value: "date", label: "Date" },
    { value: "dateorpresent", label: "Date or present" },
    { value: "document", label: "Document" },
    { value: "email", label: "E-mail" },
    { value: "file", label: "Profile" },
    { value: "linkwithlabel", label: "Label with link" },
    { value: "number", label: "Number" },
    { value: "select", label: "Select" },
    { value: "string", label: "String" },
    { value: "url", label: "URL" },
]

const AddNewEntity = ( { addDialogstate, setAddDialogState, entities } ) => {

    const [entityType, setEntityType] = useState( "string" )
    const [textfieldValue, setTextfieldValue] = useState( '' )
    const [optionValues, setOptionValues] = useState( [] )
    const [adding, setAdding] = useState( false )

    const { palette, border } = useTheme()

    const ResumeBuilderStore = useResumeBuilderStore()

    const handleChange = ( e ) => {
        setTextfieldValue( e.target.value )
    }

    const removeItem = ( i ) => {
        let newValues = [...optionValues]
        newValues.splice( i, 1 )
        setOptionValues( newValues )
    }

    const handleKeyDown = ( e ) => {
        if ( e.key === "Enter" ) {
            e.preventDefault()
            let newValues = [...optionValues]
            newValues.push( e.target.value )
            setOptionValues( newValues )
            setTextfieldValue( '' )
        }
    }

    const validationSchema = Yup.object().shape( {
        entityName: Yup.string().required( "Template name is required!" ),
        entityDescription: Yup.string().required( "Description is required!" ),
        key: Yup.string().required( "Key is required!" ),
        entityLabel: Yup.string().required( "Entity label is required!" ),
    } )

    const initialValues = {
        entityName: '',
        entityDescription: '',
        entityLabel: '',
        key: '',
        entityType: 'string',
        linkLabel: "",
        showLabel: true,
        forProctors: false,
        longText: false,
    }

    const addEntity = async ( values, { resetForm } ) => {
        let { entityName, entityDescription, key, entityLabel, entityType, linkLabel, showLabel, longText, forProctors } = values
        console.log( values )
        if ( entityType === "select" || entityType === "selectandanswer" ) {
            if ( optionValues.length < 2 ) {
                toast( "Two or more options are required for this type of entity" )
            } else {
                if ( !entities.find( i => i.entity_detail.key === key.replace( /[^\w\d]/g, "_" ).toLowerCase() ) ) {
                    setAdding( true )
                    const payload = { entityName, entityDescription, entityDetail: { key: key.replace( /[^\w\d]/g, "_" ).toLowerCase(), label: entityLabel, only_for_proctors: forProctors, label_show: showLabel, data_type: entityType, longText, link_label: linkLabel, children: optionValues } }
                    await ResumeBuilderStore.createEntity( payload )
                    await ResumeBuilderStore.fetchEntities()
                    setAddDialogState( false )
                    resetForm()
                    setEntityType( 'string' )
                    setAdding( false )
                } else {
                    toast( "Entity with that key already exists!" )
                }
            }
        }
        else {
            if ( !entities.find( i => i.entity_detail.key === key.replace( /[^\w\d]/g, "_" ).toLowerCase() ) ) {
                const payload = { entityName, entityDescription, entityDetail: { key: key.replace( /[^\w\d]/g, "_" ).toLowerCase(), label: entityLabel, only_for_proctors: forProctors, label_show: showLabel, data_type: entityType, longText, link_label: linkLabel, children: [] } }
                await ResumeBuilderStore.createEntity( payload )
                await ResumeBuilderStore.fetchEntities()
                setAddDialogState( false )
                resetForm()
                setEntityType( 'string' )
            } else {
                toast( "Entity with that key already exists!" )
            }
        }
    }

    return (
        <Dialog open={addDialogstate} slotProps={{
            paper: { sx: { maxWidth: "1050px", width: "85vw" } }
        }}>
            <Box display="flex" position="sticky" top="0" zIndex="10" bgcolor={palette.background.paper} alignItems="center" justifyContent="space-between" padding="20px" borderBottom={border[1]}>
                <Box>
                    <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Add new resume entity</Typography>
                    <Typography variant="subtitle2" fontSize="12px" color='textSecondary'>Fill in details to create a new resume entity.</Typography>
                </Box>
                <IconButton onClick={() => setAddDialogState( false )} >
                    {Icons.default.CloseIcon}
                </IconButton>
            </Box>
            <DialogContent>
                <Formik onSubmit={addEntity} validationSchema={validationSchema} initialValues={initialValues}>
                    {( { values, setFieldValue, resetForm } ) => (
                        <Form>
                            <FormControl margin="normal" sx={{ marginTop: "20px" }} fullWidth>
                                <Typography component="label" display="block" htmlFor="entity-name" gutterBottom variant="subtitle2" color={palette.form.labelColor}>Entity name *</Typography>
                                <Field id="entity-name" placeholder="Eg: Project Alpha" size="small" sx={{ fontSize: "14px" }} as={TextField} name='entityName' type='text' />
                                <FormHelperText error><ErrorMessage name='entityName' /></FormHelperText>
                            </FormControl>

                            <FormControl margin="normal" fullWidth>
                                <Typography component="label" display="block" htmlFor="entity-description" gutterBottom variant="subtitle2" color={palette.form.labelColor}>Entity description *</Typography>
                                <Field id="entity-description" placeholder="Describe the purpose" multiline rows={3} size="small" sx={{ fontSize: "14px" }} as={TextField} name='entityDescription' type='text' />
                                <FormHelperText error><ErrorMessage name='entityDescription' /></FormHelperText>
                            </FormControl>

                            <FormControl margin="normal" fullWidth>
                                <Typography component="label" display="block" htmlFor="entity-key" gutterBottom variant="subtitle2" color={palette.form.labelColor}>Entity Key *</Typography>
                                <Field id="entity-key" placeholder="e.g. entity_key" size="small" sx={{ fontSize: "14px" }} as={TextField} name='key' type='text' />
                                <Typography variant='subtitle2' fontSize="12px" color="GrayText" sx={{ mt: 0.5 }}>
                                    {values.key.replace( /[^\w\d]/g, "_" ).toLowerCase()}
                                </Typography>
                                <FormHelperText error><ErrorMessage name='key' /></FormHelperText>
                            </FormControl>

                            <FormControl margin="normal" fullWidth>
                                <Typography component="label" display="block" htmlFor="entity-label" gutterBottom variant="subtitle2" color={palette.form.labelColor}>Entity label *</Typography>
                                <Field id="entity-label" placeholder="Display name" size="small" sx={{ fontSize: "14px" }} as={TextField} name='entityLabel' type='text' />
                                <FormHelperText error><ErrorMessage name='entityLabel' /></FormHelperText>
                            </FormControl>

                            <FormControl fullWidth margin='normal'>
                                <Typography component="label" display="block" htmlFor="entity-type" gutterBottom variant="subtitle2" color={palette.form.labelColor}>Entity type * </Typography>
                                <CustomSelectField
                                    optionsMaxHeight="200px"
                                    data={allEntityTypes}
                                    size="small"
                                    value={entityType}
                                    onChange={e => { setEntityType( e.target.value ); setFieldValue( 'entityType', e.target.value ) }}
                                    placeholder="Select Entity Type"
                                    id='entity-type'
                                    itemValueKey="value"
                                    renderOptionText={item => item.label}
                                />
                                <FormHelperText error><ErrorMessage name='entityType' /></FormHelperText>
                            </FormControl>

                            <Typography sx={{ marginBottom: "20px" }} variant='subtitle2' fontSize="12px" color="error"><ErrorMessage name='entityType' /></Typography>
                            {entityType === 'linkwithlabel' &&
                                <FormControl fullWidth margin='normal'>
                                    <Typography component="label" display="block" htmlFor="link-label" gutterBottom variant="subtitle2" color={palette.form.labelColor}>Link label * </Typography>
                                    <Field id="link-label" placeholder="Eg: Visit Website" size="small" sx={{ fontSize: "14px" }} as={TextField} name='linkLabel' type='text' />
                                    <FormHelperText error><ErrorMessage name='linkLabel' /></FormHelperText>
                                </FormControl>
                            }
                            {( entityType === 'select' ) &&
                                <Box marginBottom="20px" padding="5px 0 0 5px" borderRadius="5px" border={border[1]}>
                                    <FormControl sx={{ flexGrow: 1 }} fullWidth>
                                        <TextField value={textfieldValue} onChange={handleChange} onKeyDown={handleKeyDown} sx={{ border: "1px solid rgba(0,0,0,0.1)", background: "#eee", marginRight: "10px", outline: "none", borderRadius: "5px", height: "40px", color: "black", "@media(max-width:900px)": { width: "100%" } }} placeholder={`To add options, type and press 'Enter'`} variant="standard" type="text" slotProps={{
                                            input: { disableUnderline: true, sx: { outline: "none !important", border: "none !important", height: "40px", fontSize: "14px", paddingLeft: "10px", "@media(max-width:900px)": { width: "100%" } } }
                                        }} />
                                    </FormControl>
                                    <Box padding="10px">
                                        <Typography variant='subtitle2' gutterBottom={optionValues.length !== 0} color="GrayText">{optionValues.length === 0 ? `No options Yet` : ``}</Typography>
                                        {optionValues.length > 0 && <Box display="flex" alignItems="center" gap="10px" flexWrap="wrap">
                                            {optionValues.map( ( val, i ) => (
                                                <Chip key={i} label={val} size='large' deleteIcon={Icons.default.CloseIcon} onDelete={() => { removeItem( i ) }} sx={{ border: border[1], fontSize: "14px", fontWeight: "600" }} />
                                            ) )}
                                        </Box>}
                                    </Box>
                                </Box>
                            }
                            <Box marginTop="20px" width="fit-content" display="flex" flexDirection="column" gap="5px">
                                <Box>
                                    <Field as={FormControlLabel} sx={{ margin: "0", justifyContent: "flex-start" }} labelPlacement="start" control={<Switch name="showLabel" size='small' checked={values.showLabel} onChange={() => setFieldValue( 'showLabel', !values.showLabel )} />} label={<Typography minWidth="140px" variant="subtitle2" marginRight="20px">Show label</Typography>} />
                                </Box>
                                <Box>
                                    <Field as={FormControlLabel} sx={{ margin: "0" }} labelPlacement="start" control={<Switch name="forProctors" checked={values.forProctors} onChange={() => setFieldValue( 'forProctors', !values.forProctors )} size='small' />} label={<Typography minWidth="140px" variant="subtitle2" marginRight="20px">Only for proctors</Typography>} />
                                </Box>
                                {entityType === 'string' && <Box>
                                    <Field as={FormControlLabel} sx={{ margin: "0" }} labelPlacement="start" control={<Switch name="longText" size='small' checked={values.longText} onChange={() => setFieldValue( 'longText', !values.longText )} />} label={<Typography minWidth="140px" variant="subtitle2" marginRight="20px">Long text(paragraph)</Typography>} />
                                </Box>}
                            </Box>
                            <Box display="flex" gap="10px" marginTop="20px" flexWrap="wrap" alignItems="center">
                                <Button disabled={adding} type='submit' disableElevation variant='contained' sx={{ textTransform: "capitalize" }}>
                                    <Typography variant='subtitle2' display="flex" alignItems="center" gap="10px">{adding && <CircularProgress size={14} />}{adding ? "Adding entity" : "Add entity"}</Typography>
                                </Button>
                                <Button disabled={adding} onClick={() => { resetForm(); setAddDialogState( false ) }} color="error" variant='outlined' sx={{ textTransform: "capitalize" }}>
                                    Cancel
                                </Button>
                            </Box>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    )
}

export default AddNewEntity
